import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { togglShowSideFilter } from 'src/app/actions';
import { changeUrlLanguage, getLanguage, getLanguageFromUrl, Language, LanguageId } from 'src/app/language';

@Component({
  selector: 'top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss']
})
export class TopBarComponent implements OnInit {

  @Output('onChangeLanguage') onChangeLanguage: EventEmitter<LanguageId> = new EventEmitter<LanguageId>();
  currentLanguage: LanguageId;

  languageId = LanguageId;

  constructor(private store: Store) { }

  ngOnInit() {
    this.currentLanguage = getLanguageFromUrl();
  }

  togglSideFilters() {
    return this.store.dispatch(togglShowSideFilter())
  }

  selectLanguage(language: LanguageId): void {
    return this.onChangeLanguage.emit(language);
  }

}
